import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {ConstituentsPref} from '../constants';

export const consituentClipsEnabled = (): boolean =>
	getPreference(ConstituentsPref.CLIPS_ENABLED, true);
